module.exports = __webpack_public_path__ + "static/img/light.05511f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/light.png
// module id = QQIg
// module chunks = 7